import { DashboardLayout } from "@/components/layouts";
import { authMiddleware } from "@/middleware";
import { AdminHistoryPage, PaymentHistoryPage } from "@/pages";
import { currentUserAtom } from "@/store/login";
import { createFileRoute } from "@tanstack/react-router";
import { useAtomValue } from "jotai";

export const Route = createFileRoute("/_dashboard/payment-history/")({
	component: RouteComponent,
	loader: ({ location }) => authMiddleware(location.pathname),
});

function RouteComponent() {
	const user = useAtomValue(currentUserAtom);
	const isAdmin = user?.role === "ADMIN";

	return (
		<DashboardLayout>
			{isAdmin ? <AdminHistoryPage /> : <PaymentHistoryPage />}
		</DashboardLayout>
	);
}
